export default [
  {
    path: '/etiquetas-proveedor',
    name: 'supplier-tags',
    component: () => import('@/views/supplierTags/SupplierTagsList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/nueva-etiqueta-proveedor',
    name: 'new-supplier-tag',
    component: () => import('@/views/supplierTags/SupplierTagsNew.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/editar-etiqueta-proveedor/:supplierTagId',
    name: 'editSupplierTag',
    component: () => import('@/views/supplierTags/SupplierTagsEdit.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
